// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/reference/Reference.css */
.reference-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 300;
}

.reference-prompt-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 270px;
  text-align: center;
  background-color: var(--tg-theme-bg-color);
  padding: 25px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  z-index: 1150;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.reference-title {
  width: 100%;
  color: var(--tg-theme-button-color);
  font-size: 22px;
  text-align: center;
}

.reference-url-input-field {
  width: 95%;
  font-size: 16px;
  border-radius: 12px;
  padding: 11px;
  margin: 5px;
  box-sizing: border-box;
  background-color: var(--tg-theme-bg-color);
  color: var(--tg-theme-text-color);
  border: 2px solid #8e8e8e9f;
  border-style: solid;
}

.reference-url-input-field:focus {
  outline: none;
  border-color: #00bb00;
}

.reference-image-wrapper {
  pointer-events: auto;
  position: absolute;
  background: var(--tg-theme-bg-color);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  touch-action: none;
}

.reference-image-wrapper img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.reference-close-button,
.reference-delete-button {
  position: absolute;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-theme-button-text-color);
  opacity: 0.5;
}

.reference-close-button {
  top: 0;
  right: 0;
}

.reference-delete-button {
  top: 0;
  left: 0;
}

.reference-close-button:hover,
.reference-delete-button:hover {
  opacity: 0.8;
}

.reference-button-icon {
  position: relative;
  font-size: 18px;
  color: var(--tg-theme-button-text-color);
  filter: drop-shadow(0 0 0.5px var(--tg-theme-text-color)) drop-shadow(0 0 0.5px var(--tg-theme-text-color));
}

.reference-resize-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 25px;
  height: 25px;
  border-top-left-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: se-resize;
  color: var(--tg-theme-button-text-color);
  background: #898989;
  opacity: 0.5;
}

.reference-resize-handle:hover {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/components/board/reference/Reference.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,0CAA0C;EAC1C,iCAAiC;EACjC,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,MAAM;EACN,OAAO;AACT;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,2GAA2G;AAC7G;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* src/components/reference/Reference.css */\r\n.reference-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n  z-index: 300;\r\n}\r\n\r\n.reference-prompt-container {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 270px;\r\n  text-align: center;\r\n  background-color: var(--tg-theme-bg-color);\r\n  padding: 25px;\r\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);\r\n  border-radius: 12px;\r\n  z-index: 1150;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.reference-title {\r\n  width: 100%;\r\n  color: var(--tg-theme-button-color);\r\n  font-size: 22px;\r\n  text-align: center;\r\n}\r\n\r\n.reference-url-input-field {\r\n  width: 95%;\r\n  font-size: 16px;\r\n  border-radius: 12px;\r\n  padding: 11px;\r\n  margin: 5px;\r\n  box-sizing: border-box;\r\n  background-color: var(--tg-theme-bg-color);\r\n  color: var(--tg-theme-text-color);\r\n  border: 2px solid #8e8e8e9f;\r\n  border-style: solid;\r\n}\r\n\r\n.reference-url-input-field:focus {\r\n  outline: none;\r\n  border-color: #00bb00;\r\n}\r\n\r\n.reference-image-wrapper {\r\n  pointer-events: auto;\r\n  position: absolute;\r\n  background: var(--tg-theme-bg-color);\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\r\n  overflow: hidden;\r\n  touch-action: none;\r\n}\r\n\r\n.reference-image-wrapper img {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n}\r\n\r\n.reference-close-button,\r\n.reference-delete-button {\r\n  position: absolute;\r\n  width: 30px;\r\n  height: 30px;\r\n  background: transparent;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--tg-theme-button-text-color);\r\n  opacity: 0.5;\r\n}\r\n\r\n.reference-close-button {\r\n  top: 0;\r\n  right: 0;\r\n}\r\n\r\n.reference-delete-button {\r\n  top: 0;\r\n  left: 0;\r\n}\r\n\r\n.reference-close-button:hover,\r\n.reference-delete-button:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.reference-button-icon {\r\n  position: relative;\r\n  font-size: 18px;\r\n  color: var(--tg-theme-button-text-color);\r\n  filter: drop-shadow(0 0 0.5px var(--tg-theme-text-color)) drop-shadow(0 0 0.5px var(--tg-theme-text-color));\r\n}\r\n\r\n.reference-resize-handle {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: 25px;\r\n  height: 25px;\r\n  border-top-left-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: se-resize;\r\n  color: var(--tg-theme-button-text-color);\r\n  background: #898989;\r\n  opacity: 0.5;\r\n}\r\n\r\n.reference-resize-handle:hover {\r\n  opacity: 0.8;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
